// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.send-button[data-v-d728acba] {\n  border-radius: $border-radius;\n  height: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
